export default __webpack_public_path__ + "static/media/Penny_9781408335659.65b65f3b.jpg";